module.exports = __webpack_public_path__ + "static/media/luminor-logo.8c7ffc38.svg";